import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_TITLE',
    defaultMessage: 'Neue E-Mail Adresse festlegen',
  },
  description: {
    id: 'LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_DESCRIPTION',
    defaultMessage:
      'Mit welcher E-Mail Adresse möchten Sie sich zukünftig bei XING einloggen?',
  },
  inputLabel: {
    id: 'LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_INPUT_LABEL',
    defaultMessage: 'Ihre neue E-Mail',
  },
  buttonContinue: {
    id: 'LOGIN_RECOVERY_CONTINUE',
    defaultMessage: 'Weiter',
  },
  buttonToLogin: {
    id: 'LOGIN_RECOVERY_BACK',
    defaultMessage: 'Zum Login',
  },
  invalidCode: {
    id: 'LOGIN_RECOVERY_INVALID_CODE',
    defaultMessage:
      'Leider ist der Code zum zurücksetzen des Passwortes nicht mehr gültig.',
  },
  invalidLink: {
    id: 'LOGIN_RECOVERY_INVALID_LINK',
    defaultMessage:
      'Leider ist der Link zum zurücksetzen des Passwortes nicht mehr gültig.',
  },
  problemsLoginRecoveryIntroduction: {
    id: 'LOGIN_RECOVERY_OTHER_PROBLEMS',
    defaultMessage: 'Andere Probleme beim Einloggen',
  },
  problemsLoginRecoveryLabel: {
    id: 'LOGIN_RECOVERY_OTHER_PROBLEMS_LINK_TEXT',
    defaultMessage: 'Kontaktieren Sie uns',
  },
  forgotCredentialsRecoveryLabel: {
    id: 'LOGIN_RECOVERY_FORGOT_CREDENTIALS',
    defaultMessage: 'E-Mail-Adresse / Hanynummer vergessen?',
  },
});
